import {
  useFieldArray,
  UseFieldArrayReturn,
  useFormContext,
  // useWatch,
} from "react-hook-form";

import { useAppStore } from '../store/appStore';

import { IAppForm } from "../lib/interfaces/models";

import { GuardianForm } from "./GuardianForm";
import { Button, Divider } from "@mui/material";



export const Guardians = () => {

  const form = useFormContext<IAppForm>();


  const guardiansField: UseFieldArrayReturn<IAppForm> =
    useFieldArray<IAppForm>({
      control: form.control,
      name: "guardians",
    });


  const addNewGuardian = () => {
    if (guardiansField.fields.length > 3) {
      return
    }
    guardiansField.append(
      {
        name: "",
        ssid: "",
        email1: "",
        email2: "",
        email3: "",
        tel1: "",
        tel2: "",
        tel3: "",
      }
    )
  }

  const guardian1Checked = useAppStore(state => state.guardian1Checked)

  if (guardian1Checked && guardiansField.fields.length === 0) {
    addNewGuardian()
  }


  const removeGuardian = (index: number) => {
    if (guardian1Checked && guardiansField.fields.length === 1) {
      return
    }
    guardiansField.remove(index)
  }

  return (
    <>
      {guardiansField.fields.map((field, index) => (
        <GuardianForm
          key={field.id}
          index={index}
          onRemove={removeGuardian}
          disableRemoveButton={guardian1Checked && guardiansField.fields.length === 1 ? true : false}
        />

      ))}
      <Button type="button" variant='contained' color="inherit" size='small' sx={{ m: 1 }} onClick={addNewGuardian}>
        Bæta við forráðamanni
      </Button>

      <Divider sx={{mt: 1}} />
    </>
  )





}